<template>
  <div>
    <el-container direction="vertical">
      <!-- 患者基本信息 -->
      <el-row style="margin-top: 10px;">
        <div>
          <el-row style="margin-top: 20px; padding-bottom: 18px;border-bottom: 1px solid #cecece;">
            <img style="margin-left: -10px;margin-top: 0px;width: 30px;height: 20px;" :src="linkLine" />
            <span style="font-weight: bold;font-size: 18px;">基本信息</span>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-descriptions :column="4" border>
              <el-descriptions-item label="姓名">{{ baseInfo.patientName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="性别">{{ baseInfo.gender || '-' }}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{ baseInfo.age || '-' }}</el-descriptions-item>
              <el-descriptions-item label="身份证号">{{ baseInfo.idcard || '-' }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ baseInfo.phoneNumber || '-' }}</el-descriptions-item>
            </el-descriptions>
          </el-row>
        </div>
      </el-row>
      <!-- 一体化方案 -->
      <el-row style="margin-top: 10px;">
        <div>
          <el-row style="margin-top: 20px; padding-bottom: 18px;border-bottom: 1px solid #cecece;">
            <img style="margin-left: -10px;margin-top: 0px;width: 30px;height: 20px;" :src="linkLine" />
            <span style="font-weight: bold;font-size: 18px;">一体化方案</span>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="管理标签" :span="2">{{ planData.managementTag || '-' }}</el-descriptions-item>
              <el-descriptions-item label="生活指导" :span="2">{{ planData.remarks || '-' }}</el-descriptions-item>
              <el-descriptions-item label="随访建议">{{ planData.followUpSuggestion || '-' }}</el-descriptions-item>
              <el-descriptions-item label="复查到期时间">{{ planData.reviewDueDate ? getParsedTime(planData.reviewDueDate) : '-' }}</el-descriptions-item>
            </el-descriptions>
          </el-row>
          <el-row v-if="!planLoaded" style="margin-top: 20px; text-align: center; color: #999;">
            <span>暂无一体化方案数据</span>
          </el-row>
        </div>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import imageLine from "@/assets/images/titleLine.png";
import moment from "moment";
import { getCancerManagePlanByIdcard } from "@/api/health/Lung";

export default {
  components: {},
  props: {
    pInfo: null
  },
  data() {
    return {
      linkLine: imageLine,
      baseInfo: {},
      planData: {},
      planLoaded: false
    };
  },
  created() {
    this.loadPlanData();
  },
  methods: {
    loadPlanData() {
      const idcard = this.pInfo?.idcard;
      if (!idcard) return;
      getCancerManagePlanByIdcard({ idcard }).then(res => {
        if (res.msg === 'success' && res.data) {
          const d = res.data;
          this.baseInfo = {
            patientName: d.patientName,
            gender: d.gender,
            age: d.age,
            idcard: d.idcard,
            phoneNumber: d.phoneNumber
          };
          this.planData = {
            managementTag: d.managementTag,
            followUpSuggestion: d.followUpSuggestion,
            reviewDueDate: d.reviewDueDate,
            remarks: d.remarks
          };
          this.planLoaded = true;
        }
      }).catch(err => {
        console.log('加载一体化方案失败', err);
      });
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table thead th {
  background-color: #f5f5f5 !important;
}
</style>
